import { render } from "./PVTPrediction.vue?vue&type=template&id=d7a605dc"
import script from "./PVTPrediction.vue?vue&type=script&lang=js"
export * from "./PVTPrediction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__